import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdrGlobeService, CellTower, TowerCdrStats, CdrRecord } from '../../../../core/services/cdr-globe.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-cdr-tower-details-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cdr-tower-details-modal.component.html',
  styleUrl: './cdr-tower-details-modal.component.css',
})
export class CdrTowerDetailsModalComponent {
  selectedTowerData$: Observable<{
    tower: CellTower;
    stats: TowerCdrStats;
    recentCdrs: CdrRecord[];
  } | null>;

  constructor(public cdrGlobeService: CdrGlobeService) {
    this.selectedTowerData$ = this.cdrGlobeService.selectedTower$;
  }

  close(): void {
    this.cdrGlobeService.closeTowerDetails();
  }

  flyToCity(region: string): void {
    this.cdrGlobeService.flyToCity(region);
  }
}
